<template>
  <section>
    <!-- Componentes externos -->

    <Reporte />
    <h3 class="primary--text">
      <v-icon color="primary">search</v-icon> Consulta ficha personal
    </h3>
    <!-- Boton filtro -->
    <v-tooltip bottom>
      <v-btn
        @click.native="
          () => {
            filterShow = filterShow ? false : true;
          }
        "
        class="btn-refresh"
        slot="activator"
        ><v-icon>filter_list</v-icon>
      </v-btn>
      <span>Búsqueda/filtros</span>
    </v-tooltip>

    <!-- Boton actualizar -->
    <v-tooltip bottom>
      <v-btn
        @click.native="cargarListadoPersonas()"
        class="btn-refresh"
        slot="activator"
        ><v-icon>refresh</v-icon>
      </v-btn>
      <span>{{ $t("common.updateList") }}</span>
    </v-tooltip>
    <!-- Filtros-->
    <v-card color="#CFE5F8" v-if="filterShow">
      <v-card-text class="sinMargen">
        <v-container class="filtroRRHH" grid-list-md>
          <v-layout wrap>
            <v-flex xs11></v-flex>
            <v-tooltip bottom>
              <v-btn
                icon
                slot="activator"
                color="#DDC2DF"
                @click.native="recargar()"
              >
                <v-icon>refresh</v-icon>
              </v-btn>
              <span>Recargar filtros</span>
            </v-tooltip>
            <!-- <v-tooltip bottom>
              <v-btn
                icon
                color="#DDC2DF"
                slot="activator"
                @click.native="
                  () => {
                    filterShow = false;
                    recargar();
                  }
                "
              >
                <v-icon>close</v-icon>
              </v-btn>
              <span>Cerrar filtros</span>
            </v-tooltip> -->
          </v-layout>
          <v-layout wrap>
            <v-flex xs1>
              <v-btn icon slot="activator">
                <v-icon>search</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs2>
              <v-text-field
                label="Nro. documento"
                v-model="form.nro_doc"
                type="text"
                @input="filterNroDoc(form.nro_doc)"
              ></v-text-field>
            </v-flex>
            <v-flex xs2>
              <v-text-field
                label="Item"
                type="number"
                v-model="form.item"
                @input="filterItem(form.item)"
              ></v-text-field>
            </v-flex>
            <v-flex xs2>
              <v-text-field
                label="Nombre"
                v-model="form.nombre"
                @input="filterNombre(form.nombre)"
              ></v-text-field>
            </v-flex>
            <v-flex xs2>
              <v-text-field
                label="Unidad"
                v-model="form.unidad"
                type="text"
                @input="filterUnidad(form.unidad)"
              ></v-text-field>
            </v-flex>
            <v-flex xs2>
              <v-text-field
                label="Estado"
                type="text"
                v-model="form.estado_ficha"
                @input="filterEstadoFicha(form.estado_ficha)"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <br />
    </v-card>

    <v-card>
      <v-card-text>
        <!-- <crud-table
          :headers="headers"
          :url="url"
          :filters="filters"
          :data-graphql="dataGraphql"
          :graphql="graphql"
          :initData="initData"
        > -->
        <v-data-table
          :headers="headers"
          :items="lista_fichas"
          class="elevation-1"
          :no-data-text="loading ? 'Cargando...' : 'No se tiene registros'"
          :disable-initial-sort="true"
          :loading="loading"
          no-results-text="No se encontraron coincidencias"
          item-key="index"
          :search="filters"
          :custom-filter="customFilter"
          :rows-per-page-items="[20, 40, { text: 'Todos', value: -1 }]"
        >
          <template slot="buttons"> </template>
          <template slot="items" slot-scope="items">
            <!-- <template slot="items" slot-scope="items"> -->

            <td class="text-xs-center">{{ items.item.nro_doc }}</td>
            <td class="text-xs-center">{{ items.item.item }}</td>
            <td class="text-xs-center">{{ items.item.nombre }}</td>
            <td class="text-xs-center">{{ items.item.unidad }}</td>
            <td class="text-xs-center">{{ items.item.estado_ficha }}</td>
            <td class="text-xs-center">{{ items.item.observacion }}</td>
            <td class="nowrap text-xs-center"></td>

            <td class="nowrap text-xs-center">
             
              <v-btn
                slot="activator"
                depressed
                color="primary"
                @click="reporte(items.item.id_persona)"
              >
                Ver Ficha Personal
              </v-btn>
           
            </td>
          </template>
        </v-data-table>
        <!-- </crud-table> -->
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos

import Reporte from "./dialogs/Reporte";
import Filtros from "../v_listaficha/mixins/filtros"
//import Filtros from "./mixins/filtros";

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [crud, Filtros],
  // Variables iniciales del componente
  data() {
    return {
      url: "vListafichas",
      graphql: true,
      lista_fichas: [],
      loading: false,
      form: {},
      // Variables filtros
      filters: {
        nro_doc: "",
        item: "",
        nombre: "",
        unidad: "",
        estado_ficha: "",
      },
      filterShow: true,
      // Cabecera de la tabla
      headers: [
        { text: "Número documento", value: "nro_doc", align: "center" },
        { text: "Item", value: "item", align: "center" },
        { text: "Nombre completo", value: "nombre", align: "center" },
        { text: "Unidad", value: "unidad", align: "center" },
        { text: "Estado", value: "estado_ficha", align: "center" },
        { text: "Observación", value: "observacion", align: "center" },
        { text: this.$t("common.actions"), sortable: false, align: "center" },
      ],
      // Campos solicitados de Graphql(Agregar los que necesite)
      dataGraphql: `
        id_persona
        nombre
        nro_doc
        id_estado_ficha
        estado_ficha
        habilitado
        item
        id_unidad
        unidad 
        observacion
      `,
      // Filtros del componente CrudTable ejemplo:
      // {
      // 	field: 'Campo definido en Graphql',
      // 	label: 'Etiqueta del input generado',
      // 	type: 'text', // Tipo de input en el filtro
      // 	typeG: 'String' // Tipo definido en Graphql
      // }
      // filters: [
      //   {
      //     field: "nro_doc",
      //     label: "Número de documento",
      //     type: "text", // Tipo de input en el filtro
      //     typeG: "String" // Tipo definido en Graphql
      //   },
      //   {
      //     field: "item",
      //     label: "Item",
      //     type: "number", // Tipo de input en el filtro
      //     typeG: "String" // Tipo definido en Graphql
      //   },
      //   {
      //     field: "nombre",
      //     label: "Nombre completo",
      //     type: "text", // Tipo de input en el filtro
      //     typeG: "String" // Tipo definido en Graphql
      //   },
      //   {
      //     field: "unidad",
      //     label: "Unidad",
      //     type: "text", // Tipo de input en el filtro
      //     typeG: "String" // Tipo definido en Graphql
      //   },
      //   {
      //     field: "estado_ficha",
      //     label: "Estado",
      //     type: "text", // Tipo de input en el filtro
      //     typeG: "String" // Tipo definido en Graphql
      //   }
      // ],
      initData: [
        {
          state: true,
          param: "id_estados",
          value: '"36,37,38,40"',
        },
        {
          state: true,
          param: "l_tipo_persona",
          value:[1],
        },
      ],
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    await this.cargarListadoPersonas();
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    this.onFilter();
    this.$bus.$on("closeDialog", async () => {
      await this.cargarListadoPersonas();
    });
  },
  // Métodos y funciones del componente
  methods: {

    async cargarListadoPersonas() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
							query{
							runQuery(consulta:"select * from persona.v_listaficha vl where vl.id_tipo_persona in (1) order by vl.id_persona desc"){
								respuesta
							}
							}
						`,
        });
        let resp = respuesta.runQuery.respuesta;
        this.lista_fichas = resp;
      } catch (error) {
        console.log(error);
      }
    },

    reporte(id_persona) {
      //construyo la url
      let url;
      let nombre_reporte = "";
      let formato_doc = "output=pdf";
      let nombre_carpeta = "persona";
      let url_carpeta = process.env.REPORTE_URL_OFICIAL.replace(/{carpeta}/g, nombre_carpeta);
      console.log('url_carpeta1',url_carpeta);
      //let url_carpeta = process.env.REPORTE_URL_OFICIAL.replace(/{carpeta}/g, "");
      nombre_reporte = "rpt_ficha_personal";
      url = `${url_carpeta}${nombre_reporte}&${formato_doc}`;
      //Parametros
      // URL con parametros
      let url_parametros = `${url}&ID_PERSONA=${id_persona}`;
      this.$bus.$emit("openDialogReporte", url_parametros);
      // this.guardarDocumento(url)
    },
  },
  // Definición de componentes importados
  components: {
    CrudTable,
    Reporte,

  },
};
</script>

<style>
.filtroRRHH {
  min-width: 100%;
  padding: 0em 0.5em 0em 0.5em;
}
.sinMargen {
  margin: 0em 0em 0em 0em;
  padding: 0em 0em 0em 0em;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/v_listasfichaprobar/Index.vue